/**
 * 尝试从视频URL中提取文件名
 * @param url 视频URL
 * @returns 提取的文件名或默认名称
 */
export function extractFilenameFromUrl(url: string): string {
  try {
    // 尝试从URL中提取文件名
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;
    const filename = pathname.split("/").pop();

    if (filename) {
      // 去除查询参数
      const cleanFilename = filename.split("?")[0];
      // 解码URL编码的字符
      return decodeURIComponent(cleanFilename);
    }
  } catch (error) {
    console.warn("从URL提取文件名失败:", error);
    // 如果URL不是有效格式，尝试简单分割
    const segments = url.split("/");
    const lastSegment = segments[segments.length - 1].split("?")[0];
    if (lastSegment) {
      return decodeURIComponent(lastSegment);
    }
  }

  return "未命名视频";
}

/**
 * 格式化视频时长为可读字符串
 * @param seconds 视频时长（秒）
 * @returns 格式化的时长字符串 (mm:ss)
 */
export function formatVideoDuration(seconds: number): string {
  if (!seconds || isNaN(seconds)) return "";

  const min = Math.floor(seconds / 60);
  const sec = Math.floor(seconds % 60);

  return `${min.toString().padStart(2, "0")}:${sec.toString().padStart(2, "0")}`;
}

/**
 * 将时间字符串转换为秒数
 * @param timeString 时间字符串，格式为 "MM:SS"
 * @returns 转换后的秒数
 */
export function timeStringToSeconds(timeString: string): number {
  if (!timeString) return 0;

  // 匹配 MM:SS 格式
  const match = timeString.match(/^(\d{1,2}):(\d{1,2})$/);
  if (!match) return 0;

  const minutes = parseInt(match[1], 10);
  const seconds = parseInt(match[2], 10);

  return minutes * 60 + seconds;
}
